import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import { Link } from "react-router-dom";

const GrnForRejStock = ({ showModal, closeModal, branch, itemcode, onSelectItem }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const pageSize = 10;

  useEffect(() => {
    if (showModal && itemcode) {
      fetchItems();
    }
  }, [showModal, currentPage, searchTerm, itemcode]);

  const fetchItems = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/grnRejectedDetails_forItem", {
        params: {
          branchcode: branch,
          itemcode: itemcode,
          page: currentPage,
          limit: pageSize,
          search: searchTerm,
        },
      });

      setItems(response.data.data);
      setTotalPages(Math.ceil(response.data.total / pageSize));
    } catch (error) {
      console.error("Error fetching GRN details:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectItem = (item) => {
    if (onSelectItem) {
      onSelectItem(item);
    }
    closeModal();
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  if (!showModal) return null;

  return (
    <div className="modal-item">
      <div className="modal-content-item">
        <button className="modal-close-item" onClick={closeModal}>×</button>
        <h3 className="modal-title-item">GRN Details for Rejected Closing Stock</h3>

        <div className="search-filter">
          <p>Search GRN No :</p>
          <input
            type="text"
            className="search-input"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
            }}
            placeholder="Type GRN No..."
          />
        </div>

        <div className="search-results">
          <table>
            <thead>
              <tr>
                <th>GRN No</th>
                <th>GRN Type</th>
                <th>Rejected Qty</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="5">Loading...</td></tr>
              ) : items.length > 0 ? (
                items.map((item, index) => (
                  <tr key={index}>
<td>
  <Link
    to={
      item.SourceType === "Head Office"
        ? `/inventory/grnViewSingle/${item.grnDetail_number}`
        : item.SourceType === "Branch Office"
        ? `/inventory/miscGrnViewSingle/${item.grnDetail_number}`
        : "#"
    }
  >
    {item.grnDetail_number}
  </Link>
</td>

                    {/* <td>{item.grnDetail_number}</td> */}
                    <td>{item.SourceType}</td>
                    <td>{item.grnDetail_rejectedQuantity}</td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan="5">No results found</td></tr>
              )}
            </tbody>
          </table>

          <div className="pagination-bar-item">
            <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>‹ Prev</button>
            <span>Page {currentPage} of {totalPages}</span>
            <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next ›</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GrnForRejStock;
